import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import { useFormik, FormikProvider } from "formik";
import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";import Select from "react-select";

const EditInvoicingPaymentEdit = () => {
  let { id } = useParams();
  const [value, setValue] = useState({});
  
  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
     let season_id = localStorage.getItem("season_id");


  useEffect(() => {
    axios
      .get(`/invoices/payments/edit/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          //toast.error(response.data.data.invoice_header);
          setValue(response.data.data.payment);
      
         
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const formik = useFormik({
    initialValues: {
      id: value.id,
      season_id: season_id,
      invoice_id: value.invoice_id,
      customer_id: value.customer_id,
      payment_date: value.payment_date,
      payment_amount:value.payment_amount,
      exchange_date: value.exchange_date,
      exchange_rate: value.exchange_rate,
      amount: value.amount,
      opearation_type:value.opearation_type
     
  
    },
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/invoices/payment-update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          //  actions.setSubmitting(false);
          setSubmitting(false);
          $("#form-submit").text("Update Invoice Payment");
            if (response.data.code === 200) {
              //setBackendSuccess(response.data.message);
              toast.success(response.data.message);
             // actions.resetForm();
              setTimeout(() => {
                window.location.href = "/invoices-payment/"+value.invoice_id;
              }, 1000);
            }  else if (response.data.code === 422) {
                setBackendErrors(response.data.error);
            }
            else if (response.data.code === 401) {
              setBackendErrors(response.data.error);
            }
            else {
               setBackendErrors(response.data.error);
            }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });



  const calculatePayment = (payment_amount) => {

    const exchange_rate = parseFloat(formik.values.exchange_rate);
    if (!isNaN(exchange_rate)) {
      const amount = exchange_rate * payment_amount;
      console.log(amount);
      formik.setFieldValue('amount', amount.toFixed(2)); // optional: round to 2 decimals
    }
  }

  const calculateRate = (exchange_rate) => {
  const payment = parseFloat(formik.values.payment_amount);
  if (!isNaN(payment)) {
    const amount = payment * exchange_rate;
    console.log(amount);
    formik.setFieldValue('amount', amount.toFixed(2)); // optional: round to 2 decimals
  }
  }
  
    const toggleMobileMenu = () => {
      setMenu(!menu);
  };
  

    const opearationtype = ([
    { value: 'Payment', label: "Payment" },
    { value: 'Credit Note', label: "Credit Note" },
  ]);  

const handleSelectChange = (name, selectedOption) => {
  const value = selectedOption ? selectedOption.value : "";
  updateFormikValue(name, value);
  customHandleInput({ target: { name, value } });
};

const updateFormikValue = (name, value) => {
  formik.setFieldValue(name, value);
};
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /> <ToastContainer />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Update Invoice Payment</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/invoices">
                      Invoice
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/invoices-payment/${value.invoice_id}`}>
                      Invoice payment
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Update Invoice Payment
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Update Invoice Payment Details</h4>
                    <FormikProvider value={formik}>
                      <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-md-6">
                            <div className="form-group">
                                <label> Operation Type</label>
                                <Select
                                className="w-100"
                                value={opearationtype.find(option => option.value == formik.values.opearation_type) || null} // Ensure correct format
                                name="opearation_type"
                                onChange={(selectedOption) => {
                                  handleSelectChange("opearation_type", selectedOption);
                                }}
                                onBlur={formik.handleBlur}
                                options={opearationtype}
                                placeholder="Select"   
    
                                />
                                <small>
                                  {backendErrors.opearation_type  && (
                                    <span className="form-error mt-1">
                                      {backendErrors.opearation_type}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Payment Date</label>
                                <input
                                  type="date"
                                  className="form-input form-control"
                                  name="payment_date"
                                  value={formik.values.payment_date}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.payment_date && (
                                      <span  className="form-error mt-1"   style={{ color: "red" }}    >
                                        {backendErrors.payment_date}
                                      </span>
                                    )}
                                </small>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Payment Amount</label>
                                <input
                                   type="text"
                                   onKeyPress={(event) => {
                                     // Allow only numbers (0-9)
                                     if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                   }}
                                  className="form-input form-control"
                                  name="payment_amount"
                                  value={formik.values.payment_amount}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    calculatePayment(e.target.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.payment_amount && (
                                      <span  className="form-error mt-1"   style={{ color: "red" }}    >
                                        {backendErrors.payment_amount}
                                      </span>
                                    )}
                                </small>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Exchange Date</label>
                                <input
                                  type="date"
                                  className="form-input form-control"
                                  name="exchange_date"
                                  value={formik.values.exchange_date}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.exchange_date && (
                                      <span  className="form-error mt-1"   style={{ color: "red" }}    >
                                        {backendErrors.exchange_date}
                                      </span>
                                    )}
                                </small>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Exchange Rate</label>
                                <input
                                  type="text"
                                  onKeyPress={(event) => {
                                    // Allow only numbers (0-9)
                                    if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                  }}
                                  className="form-input form-control"
                                  name="exchange_rate"
                                  value={formik.values.exchange_rate}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    calculateRate(e.target.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.exchange_rate && (
                                      <span  className="form-error mt-1"   style={{ color: "red" }}    >
                                        {backendErrors.exchange_rate}
                                      </span>
                                    )}
                                </small>
                            </div>
                          </div>
                          <div className="col-md-6">
                          <div className="form-group">
                              <label>Amount (MAD)</label>
                              
                              <div className="input-group">
                                  <input 
                                   type="text"
                                   onKeyPress={(event) => {
                                     // Allow only numbers (0-9)
                                     if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                   }}
                                  name="amount"
                                  value={formik.values.amount}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                    onBlur={formik.handleBlur}
                                  className="form-control" placeholder="Amount" aria-label="Amount" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">{'MAD'}</span>
                                  </div>
                              </div>
                              <small>
                                {backendErrors.amount && (
                                    <span className="form-error mt-1">
                                      {backendErrors.amount}
                                    </span>
                                  )}
                              </small>
                            </div>
                          </div>
                        </div>

                        <div className="text-end mt-4">
                          <button className="btn btn-primary" type="submit" id="form-submit" disabled={formik.isSubmitting}>
                          Update Invoice Payment
                          </button>
                        </div>
                      </form>
                    </FormikProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditInvoicingPaymentEdit;
